import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function SecurityCameraIcon(props) {
	return (
		<IconBase type="security-camera" {...props}>
			<path d="M3 4.5H21V7.5C21 8.05228 20.5523 8.5 20 8.5H4C3.44772 8.5 3 8.05228 3 7.5V4.5Z" />
			<path d="M14.5 15C14.5 16.3807 13.3807 17.5 12 17.5C10.6193 17.5 9.5 16.3807 9.5 15C9.5 13.6193 10.6193 12.5 12 12.5C13.3807 12.5 14.5 13.6193 14.5 15ZM13.5 15C13.5 14.1716 12.8284 13.5 12 13.5C11.1716 13.5 10.5 14.1716 10.5 15C10.5 15.8284 11.1716 16.5 12 16.5C12.8284 16.5 13.5 15.8284 13.5 15Z" />
			<path d="M19 9.5H5V12.5C5 16.366 8.13401 19.5 12 19.5C15.866 19.5 19 16.366 19 12.5V9.5ZM12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18Z" />
		</IconBase>
	);
}
SecurityCameraIcon.propTypes = iconPropTypes;
